import styled from "@emotion/styled";


export const SavedPaymentWrapper = styled.div`
  margin-left: 20px;
  margin-right: 20px;
  padding-top: 12px;

  &.hidden-layer {
    display: none;
    opacity: 0;
    transition: display 0s linear 0.33s, opacity 0.33s linear;
  }
`;
